module.exports = __webpack_public_path__ + "img/vsp0all.ee962d4c.png";